module.exports = __webpack_public_path__ + "static/img/banner02.64c71dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner02.png
// module id = oVrv
// module chunks = 1